import styles from './changeLoginPasswort.module.css';
import React, { useState } from "react";

import { usePermissionGuard } from '../../adminPanelTools';
function ChangeLoginPasswort() {
    const checking = usePermissionGuard('change_password');
    const [changeSuccesful, setchangeSuccesful] = useState(false);
    const [current, setCurrent] = useState('');
    const [newPwd, setNewPwd] = useState('');
    const [confirm, setConfirm] = useState('');
    const [status, setStatus] = useState('');



    const handleSubmit = async () => {
        if (newPwd !== confirm) {
            return setStatus("Passwörter stimmen nicht überein");
        }

        setStatus("Passwort wird gespeichert...");
        const res = await fetch('/api/auth/change-password', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({
                currentPassword: current,
                newPassword: newPwd
            })
        });

        const data = await res.json();
        if (res.ok) {
            localStorage.setItem('token', data.token); // Keep user logged in with new token
            setStatus("Passwort erfolgreich geändert!");
            setchangeSuccesful(true)
        } else {
            setStatus(data.error || "Es ist ein Problem beim Ändern aufgetreten.");
        }
    };

    if (checking) {
        return <div className={styles.container}><p>Lade...</p></div>; // or return null if you want no UI at all
    }

    return (
        <div className={styles.container}>
            <h1>Passwort ändern</h1>
            {!changeSuccesful && (
                <form className={styles.form} onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>

                    <input type="password" placeholder="Aktuelles Passwort" onChange={e => setCurrent(e.target.value)} />
                    <input type="password" placeholder="Neues Passwort" onChange={e => setNewPwd(e.target.value)} />
                    <input type="password" placeholder="Neues Passwort bestätigen" onChange={e => setConfirm(e.target.value)} />
                    <button className={styles.button} type="submit">Passwort ändern</button>


                </form>)}
            <p>{status}</p>
        </div>
    );
}
export default ChangeLoginPasswort;